import {
  TableField,
  defaultDateFormatter,
  currencyFormatter4Digits,
  moedaOuHifenFormatter,
  textoOuHifenFormatter,
} from "../../table-field";

const sequencial: TableField = {
  key: "NuSequencialItem",
  label: "#",
  tdClass: ["align-middle", "naoQuebrar", "text-left", "text-lg-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
const selecao: TableField = {
  key: "selecionado",
  label: "Selec.",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
const sequencialItemDoLote: TableField = {
  key: "NuSequencialItemLote",
  label: "#",
  tdClass: ["align-middle", "naoQuebrar", "text-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

const descricao: TableField = {
  key: "DeItemMatServ",
  label: "Descrição do item",
  tdClass: ["align-middle", "text-left", "quebrarPorPalavra"],
  thClass: ["text-left", "quebrarPorPalavraHard"],
  sortable: false,
};

const Vencedor: TableField = {
  key: "Vencedor",
  label: "Vencedor do item",
  tdClass: "align-middle",
  thClass: "text-center",
  sortable: false,
};

const QtLicitada: TableField = {
  key: "QtLicitada",
  label: "Quantidade Licitada",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

const VlUnitarioLicitado: TableField = {
  key: "VlUnitarioLicitado",
  label: "Valor Unitário Licitado",
  tdClass: "align-middle",
  thClass: ["text-center", "quebrarPorPalavraHard"],
  sortable: false,
  formatter: currencyFormatter4Digits,
};

const fracassado: TableField = {
  key: "FlFracassado",
  label: "Fracassado?",
  tdClass: ["align-middle", "text-left", "text-lg-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

const participante: TableField = {
  key: "NmParticipante",
  label: "Participante",
  tdClass: ["align-middle", "quebrarPorPalavraHard"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
const vlTotalEstimado: TableField = {
  key: "VlTotalEstimado",
  label: "Valor total Est.",
  tdClass: ["align-middle", "text-left", "text-lg-right", "quebrarPorPalavraHard"],
  thClass: ["text-right", "quebrarPorPalavraHard"],
  sortable: false,
  formatter: currencyFormatter4Digits,
};
const vlTotalLicitado: TableField = {
  key: "VlTotalLicitado",
  label: "Valor Total Licitado",
  tdClass: ["align-middle", "text-left", "text-lg-right", "quebrarPorPalavraHard"],
  thClass: ["text-right", "quebrarPorPalavraHard"],
  sortable: false,
  formatter: currencyFormatter4Digits,
};
export const dtHomologacao: TableField = {
  key: "DtHomologacaoItem",
  label: "Data de Homologação",
  tdClass: "align-middle",
  thClass: ["text-center", "quebrarPorPalavraHard"],
  sortable: false,
  formatter: defaultDateFormatter,
};
const qtItemMatServ: TableField = {
  key: "QtItemMatServ",
  label: "Quantidade",
  tdClass: ["align-middle", "text-left", "text-lg-right", "naoQuebrar"],
  thClass: ["text-right", "naoQuebrar"],
  sortable: false,
};

export function quantidadeComUnidadeFormatter(
  valor: number,
  _key: string,
  item: { DeUnidadeMedida?: string }
): string {
  const unidade = String(item?.DeUnidadeMedida ?? "")
    .replace(/\s+/g, " ")
    .trim();

  return unidade ? `${valor} ${unidade}` : String(valor ?? "");
}

export function quantidadeDisponivelComUnidade(
  item: { DeUnidadeMedida?: string; QtItemMatServ?: number; QtLicitada?: number; QtDisponivelParaLicitar?: number }
): string {
  const unidade = String(item?.DeUnidadeMedida ?? "")
    .replace(/\s+/g, " ")
    .trim();

  const total = Number(item?.QtDisponivelParaLicitar ?? item?.QtItemMatServ ?? 0);
  const licitada = Number(item?.QtLicitada ?? 0);
  const disponivel = Math.max(0, total - licitada);
  const inteiro = Number.isInteger(disponivel);

  const quantidadeDisponivel = Number.isFinite(disponivel)
    ? disponivel.toLocaleString("pt-BR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: inteiro ? 0 : 4,
    })
    : "0";

  return unidade
    ? `${quantidadeDisponivel} ${unidade}`
    : quantidadeDisponivel;
}

const qtItemMatServModalPorVencedor: TableField = {
  ...qtItemMatServ,
  label: "Quantidade estimada",
  formatter: quantidadeComUnidadeFormatter,
};
const DeUnidadeMedida: TableField = {
  key: "DeUnidadeMedida",
  label: "Unidade medida",
  tdClass: ["align-middle", "text-left"],
  thClass: ["text-left", "quebrarPorPalavraHard"],
  sortable: false,
};
const vlUnitarioEstimado: TableField = {
  key: "VlUnitarioEstimado",
  label: "Valor Estimado (Unitário)",
  tdClass: ["align-middle", "text-left", "text-lg-right", "quebrarPorPalavra"],
  thClass: ["text-right", "quebrarPorPalavraHard"],
  sortable: false,
  formatter: currencyFormatter4Digits,
};

const vlUnitarioLicitado: TableField = {
  key: "VlUnitarioLicitado",
  label: "Valor Licitado (Unitário)",
  tdClass: ["align-middle", "text-left", "text-lg-right", "naoQuebrar"],
  thClass: ["text-right", "quebrarPorPalavraHard"],
  sortable: false,
  formatter: currencyFormatter4Digits,
};

const vlUnitarioLicitadoModalPorVencedor: TableField = {
  ...vlUnitarioLicitado,
  formatter: moedaOuHifenFormatter,
};

const nmMarcaItemMatServ: TableField = {
  key: "NmMarcaItemMatServ",
  label: "Marca do item",
  tdClass: "align-middle",
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

const nmMarcaItemMatServModalPorVencedor: TableField = {
  ...nmMarcaItemMatServ,
  formatter: textoOuHifenFormatter,
};

const nomeCredor: TableField = {
  key: "nomeCredor",
  label: "Credor",
  tdClass: ["align-middle", "quebrarPorPalavraHard"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

export const nmCredor: TableField = {
  key: "NmCredor",
  label: "Credor",
  tdClass: ["align-middle", "quebrarPorPalavra"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

export const fieldsItemLicitacao: TableField[] = [
  sequencial,
  descricao,
  qtItemMatServ,
  DeUnidadeMedida,
  vlUnitarioEstimado,
  vlTotalEstimado,
];

export const fieldsEditarItensLoteLicitacao: TableField[] = [
  sequencialItemDoLote,
  descricao,
  qtItemMatServ,
  DeUnidadeMedida,
  vlUnitarioEstimado,
  vlTotalEstimado,
];

export const fieldsItemDispensa: TableField[] = [
  sequencial,
  descricao,
  qtItemMatServ,
  DeUnidadeMedida,
  vlUnitarioEstimado,
  vlTotalEstimado,
  nomeCredor,
];

export const fieldsItemVencedorLicitacao: TableField[] = [
  sequencial,
  descricao,
  qtItemMatServ,
  DeUnidadeMedida,
  vlUnitarioEstimado,
  vlTotalEstimado,
  fracassado,
  vlTotalLicitado,
];

/** painel de resumo de itens selecionados no modal por vencedor */
export const fieldsResumoSelecionadosModalPorVencedor: TableField[] = [
  sequencial,
  descricao,
  QtLicitada,
  vlUnitarioLicitadoModalPorVencedor,
  nmMarcaItemMatServModalPorVencedor,
];

/** modal onde se escolhe 1 vencedor e cadastra todos os itens que ele venceu */
export const fieldsModalPorVencedor: TableField[] = [
  selecao,
  sequencial,
  descricao,
  qtItemMatServModalPorVencedor,
  QtLicitada,
  vlUnitarioLicitadoModalPorVencedor,
  nmMarcaItemMatServModalPorVencedor,
];

export const fieldsItemLoteVencedorLicitacao: TableField[] = [
  sequencial,
  descricao,
  qtItemMatServ,
  DeUnidadeMedida,
  vlUnitarioLicitado,
  vlTotalLicitado,
  nmMarcaItemMatServ,
  vlTotalEstimado,
];

export const fieldsVencedoresItemHmlParcial: TableField[] = [
  Vencedor,
  nmMarcaItemMatServ,
  QtLicitada,
  VlUnitarioLicitado,
  dtHomologacao,
];

export const fieldsVencedoresItem: TableField[] = [
  Vencedor,
  nmMarcaItemMatServ,
  QtLicitada,
  VlUnitarioLicitado,
];

export const detalhesVencedores: TableField = {
  key: "detalhesVencedores",
  label: "Ver Vencedores",
  tdClass: ["align-middle", "w7remLg", "text-left", "text-lg-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

export const fieldEdicaoItemLicitacao: TableField = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions"],
  thClass: "text-center",
  sortable: false,
};

export const fieldEdicaoVencedoresItem: TableField = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions"],
  thClass: "text-center",
  sortable: false,
};
